import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts', {
        url: '/accounts',
        component: 'companyUserDirectoriesManageGroupAccounts',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/group-accounts.state.js